document.addEventListener('DOMContentLoaded', function () {
  lightbox.option({
    fadeDuration: 600,
  fitImagesInViewport:true,
  imageFadeDuration: 600,
  minWidth: 800,
  maxHeight: 600,
  positionFromTop: 50,
  resizeDuration: 700,
  showImageNumberLabel:true,
  wrapAround:true,
  });

  // Swiper Initialization for main image and thumbnails
  const mainSwiper = new Swiper('.swiper-main', {
    loop: false,
    slidesPerView: 1,
    thumbs: {
      swiper: {
        el: '.swiper-thumbnails',
        slidesPerView: 'auto',
        spaceBetween: 10,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      },
    },
    on: {
      slideChange: function () {
        const activeIndex = mainSwiper.activeIndex;
        updateZoomEffect(activeIndex); // Update zoom effect based on active slide
        thumbnailSwiper.slideTo(activeIndex); // Sync thumbnails with the main image
      },
    },
  });

  const thumbnailSwiper = new Swiper('.swiper-thumbnails', {
    slidesPerView: 'auto',
    spaceBetween: 30,
    freeMode: true,
    simulateTouch: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
  });

  thumbnailSwiper.on('click', function (swiper, e) {
    const clickedSlideIndex = swiper.clickedIndex;
    mainSwiper.slideTo(clickedSlideIndex); // Update main image based on clicked thumbnail
  });

  mainSwiper.on('slideChange', function () {
    const slides = document.querySelectorAll('.swiper-thumbnails .swiper-slide');
    slides.forEach((slide, index) => {
      if (index === mainSwiper.activeIndex) {
        slide.style.opacity = '1'; // Highlight active thumbnail
      } else {
        slide.style.opacity = '0.6'; // Dim others
      }
    });
  });

  // Initial zoom effect on the first image
  updateZoomEffect(mainSwiper.activeIndex);
});


